var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "multiselect",
        {
          attrs: {
            "select-label": _vm.customSelectLabel,
            "deselect-label": _vm.customDeselectLabel,
            placeholder: _vm.customPlaceholder,
            options: _vm.languages,
            multiple: true,
            "close-on-select": true,
            "clear-on-select": false,
            max: 30,
            label: "name",
            "track-by": "name",
            searchable: true,
            "preselect-first": true,
            selectedLabel: _vm.customSelectedLabel,
            limit: 30,
          },
          on: { input: _vm.addValueToInput },
          model: {
            value: _vm.value,
            callback: function ($$v) {
              _vm.value = $$v
            },
            expression: "value",
          },
        },
        [
          _c("template", { slot: "maxElements" }, [
            _vm._v(_vm._s(_vm.customMaxElementsText)),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }